import React from 'react';
import { connect } from 'react-redux';

import {PieChart, Pie, ResponsiveContainer, Cell} from 'recharts';
import { Metric, ComponentWithUrl, FACEBOOK_COLORS, TWITTER_COLORS } from './../../../Utils/Utils.js';
import Loader from '../../../Loader/Loader.js';
import numeral from '../../../../../node_modules/numeraljs/numeral.js';

class SocialGoalsInstagramVimeo extends ComponentWithUrl {
 render() {
   const { loading, data, title, facebook_goal, twitter_goal } = this.props;

   if (loading) {
     return (
       <Loader minHeight={400} col={'col-sm-6 col-md-6'} />
     );
   }

   const facebook_percentage = data.facebook.value * 100 / facebook_goal
   const twitter_percentage = data.twitter.value * 100 / twitter_goal

   const graph_data = {
     "facebook_count": [{
         "value": facebook_percentage
       }, {
         "value": facebook_percentage > 100 ?  0 : 100 - facebook_percentage
       }],
     "twitter_count": [{
       "value": twitter_percentage
        }, {
        "value": twitter_percentage > 100 ?  0 : 100 - twitter_percentage
      }]
   };

   return (

     <div className="col-xs-12 col-md-6 d-flex">
       <div className="widget">
         <header className="widget__header">
           <h5 className="widget__title">{title}</h5>
         </header>

         <div className="row mt-3">
           <div className="col-6 col-sm-6 col-md-6">
             <h5 className="widget__subtitle widget--facebook">Facebook</h5>
             <h6 className="mb-0">Followers</h6>
             <Metric {...data.facebook} size={"md"}/>
           </div>

           <div className="col-6 col-sm-6 col-md-6">
             <h5 className="widget__subtitle widget--vimeo">Twitter</h5>
             <h6 className="mb-0">Followers</h6>
             <Metric {...data.twitter} size={"md"}/>
           </div>
         </div>

         <div className="row mt-3">
           <div className="col-6">
               <ResponsiveContainer height={270}>
                 <PieChart height={100}>
                   <Pie dataKey="value" startAngle={180} endAngle={0} data={graph_data.facebook_count} outerRadius="100%" innerRadius="80%">
                  {
                    graph_data.facebook_count.map((entry, index) => (
                      <Cell key={`cell-${entry}`} fill={FACEBOOK_COLORS[index]} />
                    ))
                  }
                 </Pie>
                 <text x="50%" y="40%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__primary">
                   { numeral(facebook_percentage).divide(100).format('%') }
                 </text>
               </PieChart>
              </ResponsiveContainer>

              <div className="piechart-metric__secondary">
                <h6 className="text-muted text-center">{ numeral(facebook_goal).format(0.0) } Goal</h6>
              </div>
           </div>

           <div className="col-6">

               <ResponsiveContainer height={270}>
                 <PieChart height={100}>
                   <Pie dataKey="value" startAngle={180} endAngle={0} data={graph_data.twitter_count} outerRadius="100%" innerRadius="80%">
                  {
                    graph_data.twitter_count.map((entry, index) => (
                      <Cell key={`cell-${entry}`} fill={TWITTER_COLORS[index]} />
                    ))
                  }
                 </Pie>
                 <text x="50%" y="40%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__primary">
                   { numeral(twitter_percentage).divide(100).format('%') }
                 </text>
               </PieChart>
              </ResponsiveContainer>

              <div className="piechart-metric__secondary">
                <h6 className="text-muted text-center">{ numeral(twitter_goal).format(0.0) } Goal</h6>
              </div>
           </div>
         </div>
       </div>
     </div>
   );
 }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true,
  };
};

export default connect(mapStateToProps)(SocialGoalsInstagramVimeo);
